import axios, { AxiosRequestConfig } from 'axios';
import {getBuildNumber,getVersion} from 'react-native-device-info';
import { isNetworkAvailable } from '../../hooks/useConnection';
import { IStreamRefreshTokenResponse } from '../../interface/streamLoginResponse';
import { useAppPersistenceStore } from '../../store/useAppPersistenceStore';
import { useProfileStore } from '../../store/useProfileStore';
import { handleRetry } from '../../utils/handleRetry';
import paths, { getStreamURI } from '../paths';
import { Platform } from 'react-native';
import { webBuildNumber } from '@ninjacart/nc-nk-core';

export const StreamClient = axios.create({
  baseURL: getStreamURI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
    ...(useProfileStore?.getState().streamConfig?.access_token && {
      Authorization: `Bearer ${useProfileStore.getState().streamConfig?.access_token}`,
    }),
    ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

StreamClient.interceptors.request.use(async (config) => {
  // await syncStreamChannels();
  const isConnected = isNetworkAvailable();
  if (!isConnected) {
    console.log('Network in not connected!!!');
    return Promise.reject('No internet available!!!');
  }

  if (useProfileStore?.getState()?.streamConfig?.access_token) {
    config.headers.Authorization = `Bearer ${useProfileStore?.getState()?.streamConfig?.access_token}`;
  }

  config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage;

  // StreamClient.interceptors.request.eject(interceptor);
  return Promise.resolve(config);
});

StreamClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (
      (error.response.status === 401 || !useProfileStore.getState()?.streamConfig?.access_token) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const userId = useProfileStore.getState()?.userProfile?.user?.id ?? null;
        if (!userId) {
          // throw new Error('Without user id exchange token api cannot be invokable');
          console.log('No user id present!!!');
          return;
        }

        const streamToken = useProfileStore.getState().userProfile?.access_token;
        const config: AxiosRequestConfig = {
          headers: {
            Authorization: `Bearer ${streamToken}`,
          },
        };

        const response = await axios.get<IStreamRefreshTokenResponse>(
          paths.getStreamTokenOnExpiry(userId),
          config
        );

        console.log('Access token new => ', response.data?.data?.peerTube.access_token);
        useProfileStore.getState()?.setStreamConfig(response.data?.data?.peerTube);

        // Retry the original request with the new token
        originalRequest.headers.Authorization = response.data?.data?.peerTube?.access_token
          ? `Bearer ${response.data?.data?.peerTube?.access_token}`
          : '';
        originalRequest.headers['x-language-code'] =
          useAppPersistenceStore?.getState()?.appLanguage;
        return axios(originalRequest);
      } catch (error) {
        // Handle refresh token error or redirect to login
        console.error('Unable to get peertube access token on expiry.', error);
      }
    }

    const config = error.config;
    return handleRetry(error, config, 'STREAM_CLIENT_API_FAILED', StreamClient);

    // return Promise.reject(error);
  }
);
